import React, { useState } from 'react';
import { Query } from '@kentik/ui-shared/query/query.types';
import { Box, Collapse, Flex, Heading, Icon } from 'core/components';
import UdeDataViewWrapper from 'app/components/dataviews/ude/UdeDataViewWrapper';

interface CollapsibleChartProps {
  title: string;
  query: Query;
  chartHeight: number;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  chartOverrides: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  settings: any;
}

/**
 * A metric chart with a Grafana-style collapsible header. When collapsed, Blueprint's Collapse
 * unmounts the body, so UdeDataViewWrapper's cleanup runs (SSE unsubscribe → data dumped). Expanding
 * remounts it, which re-runs the query.
 */
const CollapsibleChart = ({ title, query, chartHeight, chartOverrides, settings }: CollapsibleChartProps) => {
  const [isOpen, setIsOpen] = useState(true);

  return (
    <Box mb={isOpen ? '20px' : '2px'}>
      <Flex
        alignItems="center"
        gap="6px"
        py={isOpen ? '6px' : '2px'}
        role="button"
        tabIndex={0}
        aria-expanded={isOpen}
        style={{ cursor: 'pointer', userSelect: 'none' }}
        onClick={() => setIsOpen((open) => !open)}
        onKeyDown={(e: React.KeyboardEvent) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            setIsOpen((open) => !open);
          }
        }}
      >
        <Icon icon={isOpen ? 'caret-down' : 'caret-right'} iconSize={16} />
        <Heading level={5} m={0}>
          {title}
        </Heading>
      </Flex>
      <Collapse isOpen={isOpen}>
        <Box height={chartHeight} display="flex" flexDirection="column">
          <UdeDataViewWrapper
            query={query}
            showOpenInUde
            chartOverrides={chartOverrides}
            settings={settings}
            legendMaxWidth={400}
            flex={1}
            minHeight={0}
            height="auto"
          />
        </Box>
      </Collapse>
    </Box>
  );
};

export default CollapsibleChart;
